import { Person, SmartToy } from "@mui/icons-material";
import { Avatar, useTheme } from "@mui/material";
import React from "react";

interface ChatAvatarProps {
  variant: "user" | "assistant";
}

const ChatAvatarComponent: React.FC<ChatAvatarProps> = ({ variant }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const { chatTheme } = theme;
  const colors =
    variant === "user"
      ? isDarkMode
        ? chatTheme.colors.user.dark
        : chatTheme.colors.user.light
      : isDarkMode
        ? chatTheme.colors.assistant.dark
        : chatTheme.colors.assistant.light;

  return (
    <Avatar
      sx={{
        bgcolor: colors.background,
        color: colors.text,
        width: chatTheme.avatar.size,
        height: chatTheme.avatar.size,
        flexShrink: 0,
      }}
    >
      {variant === "user" ? <Person fontSize="small" /> : <SmartToy fontSize="small" />}
    </Avatar>
  );
};

export const ChatAvatar = React.memo(ChatAvatarComponent);
